import * as types from '@/constants/mutationTypes'

const state = {
  newMessage: {
    open: false,
    openFullSize: false
  }
}
const getters = {
  newMessage: state => state.newMessage
}
const actions = {
  setNewMessage ({commit}, data) {
    commit(types.SET_NEW_MESSAGE, {data})
  }
}
const mutations = {
  [types.SET_NEW_MESSAGE] (state, {data}) {
    state.newMessage = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Email/modules/newMessage.js